// Modules
import { createFeatureSelector, createSelector } from '@ngrx/store';

// Store - Reducers
import { ForcedPasswordChangeState } from '@store/reducers/forced-password-change.reducer';

export const selectForcedPasswordChangeState =
  createFeatureSelector<ForcedPasswordChangeState>('forcedPasswordChange');

export const selectForcedPasswordChangePending = createSelector(
  selectForcedPasswordChangeState,
  (state: ForcedPasswordChangeState) => state.pending
);

export const selectForcedPasswordChangeChallengeId = createSelector(
  selectForcedPasswordChangeState,
  (state: ForcedPasswordChangeState) => state.challengeId
);

export const selectForcedPasswordChangeChanging = createSelector(
  selectForcedPasswordChangeState,
  (state: ForcedPasswordChangeState) => state.changing
);

export const selectForcedPasswordChangeFieldError = createSelector(
  selectForcedPasswordChangeState,
  (state: ForcedPasswordChangeState) => state.fieldError
);

// Combined selector for guard: both pending AND challengeId present
export const selectForcedPasswordChangeCanAccess = createSelector(
  selectForcedPasswordChangeState,
  (state: ForcedPasswordChangeState) => state.pending && !!state.challengeId
);
